export default "__VITE_ASSET__Byg8NboR__"